/**
 * Copyright © Veeam Software Group GmbH.
 */

export const resetFormState = (formObj: Record<string, any>): void => {
    Object.keys(formObj).forEach((key) => {
        formObj[key] = '';
    });
};
